import { render, staticRenderFns } from "./FilterButton.vue?vue&type=template&id=24bd8e1f&scoped=true&lang=pug&"
import script from "./FilterButton.vue?vue&type=script&lang=js&"
export * from "./FilterButton.vue?vue&type=script&lang=js&"
import style0 from "./FilterButton.vue?vue&type=style&index=0&id=24bd8e1f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bd8e1f",
  null
  
)

export default component.exports